import { Link } from 'react-router-dom'
import { Tag } from '@/components/ui/Tag'
import type { Project } from '@/types/content'
import styles from './ProjectCard.module.css'

/**
 * A real link to `/projects/:slug`. Because it is a link rather than the old
 * button that toggled `display: block`, every project is shareable, opens in a
 * new tab on middle-click, and closes with the back button.
 */
export function ProjectCard({ project }: { project: Project }) {
  return (
    <article className={styles.card}>
      <Link to={`/projects/${project.slug}`} className={styles.link}>
        <div className={styles.media}>
          <img
            src={project.cover.src}
            alt={project.cover.alt}
            loading="lazy"
            decoding="async"
          />
          {project.status === 'wip' && <span className={styles.status}>In progress</span>}
        </div>

        <div className={styles.content}>
          <div className={styles.headline}>
            <h3 className={styles.title}>{project.title}</h3>
            {project.period && <span className={styles.period}>{project.period}</span>}
          </div>
          <p className={styles.summary}>{project.summary}</p>
          <ul className={styles.tags}>
            {project.tags.map((tag) => (
              <li key={tag}>
                <Tag name={tag} size="sm" />
              </li>
            ))}
          </ul>
        </div>
      </Link>
    </article>
  )
}
